<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Přidat novou událost</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="Název události" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <datepicker label="Datum od" class="mx-2" v-model="datum" clearable></datepicker>
                </v-flex>
                <v-flex xs12 sm6>
                  <datepicker label="Datum do" class="mx-2" v-model="datum" clearable></datepicker>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Místo konání" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Limit účastníků" class="mx-2" type="number" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    label="Zpoplatnění"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Přidat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="1400px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Detail události</h2>
        </v-card-title>
        <div v-if="!editMode">
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Název události:</p> <strong>Porada vedení společnosti</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Typ události:</p> <strong>Porada</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Pořadatel:</p> <strong>Jan Novák</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Datum konání:</p> <strong>23. - 25. 4. 2019</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Místo konání:</p> <strong>Praha</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Limit počtu účastníků:</p> <strong>20</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Školitel:</p> <strong>Jan Novák</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <p class="grey--text caption mb-1">Popis události:</p>
                  <strong>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis, numquam.
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis, numquam.
                  </strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <p class="grey--text caption mb-1">Obsah události:</p>
                  <strong>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Rem harum dolore facere!
                  </strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Zpoplatněno:</p> <strong>Ano</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Cena pro klienta:</p> <strong>200 Kč</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Cena pro spolupracovníka:</p> <strong>200 Kč</strong>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <p class="grey--text caption mb-1">Cena pro tipaře:</p> <strong>200 Kč</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <p class="grey--text caption mb-1">Dokumenty k události:</p>
                  <v-btn color="primary" class="ma-0 mr-1" depressed>Soubor</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-5">
                <v-flex>
                  <h3>Účastníci události</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-2" align-center>
                <v-flex xs12 sm4>
                  <v-select
                    label="Výběr skupiny účastníků"
                    class="mx-1 my-0"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm5 class="text-xs-center text-sm-right">
                  <v-btn color="primary" class="ma-0" :class="{'mt-3': $vuetify.breakpoint.smAndDown}" depressed><v-icon class="mr-2">person_add</v-icon> Přidat skupinu účastníků</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-2">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1 mt-2">
                    <v-data-table
                      :headers="headersUcastnici"
                      :items="itemsUcastnici"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.datum_faktury_zbozi }}</td>
                        <td>{{ props.item.cislo_faktury_zbozi }}</td>
                        <td width="200">
                          <v-text-field
                            suffix="EUR"
                            type="number"
                          ></v-text-field>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="editMode=true">Upravit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
          </v-card-actions>
        </div>
        <div v-else>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Název události" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Typ události"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <datepicker label="Datum od" class="mx-2" v-model="datum" clearable></datepicker>
                </v-flex>
                <v-flex xs12 sm6>
                  <datepicker label="Datum do" class="mx-2" v-model="datum" clearable></datepicker>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field label="Místo konání" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Limit účastníků" class="mx-2" type="number" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Školitel" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="Popis události" hide-details class="ma-2" textarea></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Obsah události" hide-details class="ma-2" textarea></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-select
                    label="Zpoplatnění"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Cena pro klienta" suffix="Kč" type="number" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-checkbox label="Stejné ceny"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-text-field label="Cena pro spolupracovníka" suffix="Kč" type="number" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field label="Cena pro tipaře" suffix="Kč" type="number" class="mx-2"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-btn color="primary" depressed><v-icon class="mr-2">cloud_upload</v-icon>Nahrát dokument</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3" align-center>
                <v-flex>
                  <h3 :class="{'mb-3': $vuetify.breakpoint.smAndDown}">Účastníci události</h3>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex>
                  <div class="right" :class="{'text-xs-center text-sm-center': $vuetify.breakpoint.smAndDown}">
                    <v-btn color="primary" class="mx-1 my-0" :class="{'mb-3': $vuetify.breakpoint.smAndDown}" depressed><v-icon class="mr-2">add</v-icon> Přidat účastníka</v-btn>
                    <v-btn color="primary" class="mx-1 my-0" :class="{'mb-3': $vuetify.breakpoint.smAndDown}" depressed><v-icon class="mr-2">person_add</v-icon> Pozvat všechny účastníky</v-btn>
                    <v-btn color="primary" class="mx-1 my-0" depressed><v-icon class="mr-2">people</v-icon> Vygenerovat prezenční listinu</v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-2">
                <v-flex xs12>
                  <div class="table-border__radius elevation-1">
                    <v-data-table
                      :headers="headersUcastnici"
                      :items="itemsUcastnici"
                      hide-actions
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.datum_faktury_zbozi }}</td>
                        <td>{{ props.item.cislo_faktury_zbozi }}</td>
                        <td width="200">
                          <v-text-field
                            suffix="EUR"
                            type="number"
                          ></v-text-field>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="editMode=false">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
          </v-card-actions>
        </div>
      </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm9>
                <h3>Přehled událostí</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3 class="text-xs-left text-md-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat událost
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.nazev }}</td>
                  <td>{{ props.item.datum }}</td>
                  <td>{{ props.item.misto }}</td>
                  <td>{{ props.item.limit }}</td>
                  <td>{{ props.item.zpoplatneni }}</td>
                  <td class="text-center">
                    <v-btn color="primary" class="elevation-0 ma-0" @click="detailClick(props.item)">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                    <v-btn color="primary" flat class="elevation-0 ma-0">
                      <v-icon small class="mr-2">clear</v-icon> Zrušit akci
                    </v-btn>
                    <v-btn color="primary" flat class="elevation-0 ma-0" v-if="zruseno">
                      <v-icon small class="mr-2">clear</v-icon> Akce zrušena
                    </v-btn>
                    <v-btn flat icon color="red" class="elevation-0">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      zruseno: false,
      headers: [
        { text: 'Název události', value: 'nazev' },
        { text: 'Datum konání', value: 'datum' },
        { text: 'Místo údálosti', value: 'misto' },
        { text: 'Limit účastníků', value: 'limit' },
        { text: 'Zpoplatnění', value: 'zpoplatneni' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      headersUcastnici: [
        { text: 'Jméno a příjmení', value: 'jmeno' },
        { text: 'Email', value: 'email' },
        { text: 'Telefon', value: 'telefon' },
        { text: 'Výše poplatku', value: 'poplatek' },
        { text: 'Přihlášen', value: 'prihlasen' },
        { text: 'Poplatek uhrazen', value: 'poplatek_uhrazen' },
        { text: 'Zúčastnil se', value: 'zucastnil' },
        { text: 'Poznámka', value: 'poznamka' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      items: [
        {
          nazev: 'Meeting',
          datum: '12. 4. 2019 - 15. 4. 2019',
          misto: 'Praha',
          limit: '20',
          zpoplatneni: 'Ne'
        },
        {
          nazev: 'Školení',
          datum: '28. 3. 2019 - 2. 4. 2019',
          misto: 'Plzeň',
          limit: '15',
          zpoplatneni: 'Ne'
        }
      ],
      selects: [
        'Ano',
        'Ne'
      ],
      dialogCreate: false,
      dialogDetail: false
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {
    createClick () {
      this.dialogCreate = true;
    },
    detailClick () {
      this.dialogDetail = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Udalosti/Udalosti.vue